import { useContext } from 'react';

import { useTranslation } from 'react-i18next';

import VirtualAgentContext from '../virtual-agent/virtualAgentContext';
import SecondaryButton from '../secondary-button/secondary-button';

export interface VirtualAgentChatButtonProps {
  handleOnClickAction?: () => unknown;
}
const VirtualAgentChatButtonComponent = (
  props: VirtualAgentChatButtonProps
) => {
  const { handleOnClickAction } = props;
  const { t } = useTranslation();
  const { chatEnabled } = useContext(VirtualAgentContext) ?? {};
  const handleButtonClick = async () => {
    if (handleOnClickAction) handleOnClickAction();
  };
  return (
    <SecondaryButton
      tabIndex={0}
      appearance="secondary"
      disabled={false}
      data-testid="chatUs"
      id="chat-us"
      className="chat-button"
      onClick={!chatEnabled ? undefined : handleButtonClick}
    >
      {t('footer.chatUs')}
    </SecondaryButton>
  );
};

export default VirtualAgentChatButtonComponent;
